/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Custom_Property_Link_Rule_Type_CallInputs */

const en_enum_custom_property_link_rule_type_call = /** @type {(inputs: Enum_Custom_Property_Link_Rule_Type_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property Link Rule Type Call`)
};

const de_enum_custom_property_link_rule_type_call = /** @type {(inputs: Enum_Custom_Property_Link_Rule_Type_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anruf Link`)
};

/**
* | output |
* | --- |
* | "Property Link Rule Type Call" |
*
* @param {Enum_Custom_Property_Link_Rule_Type_CallInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_custom_property_link_rule_type_call = /** @type {((inputs?: Enum_Custom_Property_Link_Rule_Type_CallInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Custom_Property_Link_Rule_Type_CallInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_custom_property_link_rule_type_call(inputs)
	return de_enum_custom_property_link_rule_type_call(inputs)
});